declare var swal: any;
import { Component, OnInit, Input } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";

import { Router, ActivatedRoute, Params } from '@angular/router';

import * as alertFunctions from '../../../../shared/data/sweet-alerts';


declare var require: any;

import { ApiResponseModel } from '../../../../../../src/app/ncs/models/api_response_model';
import { NgbModal, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ActorService } from '../../../../../../src/app/ncs/services/actor.service';
import { routerTransition } from '../../../../../../src/app/ncs/animations/router.animations';
import { NgbAddBill } from './modal/addbill.modal';
import { NgbPayBillModal } from './paybill.modal';
import {
  MaterialsListController,
  MaterialsListRequest, 
 SavePurchaseIndentRequest, SavePurchaseIndentItem, S_Methods
} from '../../../../../../src/app/ncs/models/actor/actor';
import { PatientInfoByFormattedCodeRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { AppData } from '../../../../../../src/app/ncs/models/appdata';
import { SpinnerService } from '../../../../../../src/app/ncs/services/spinner.service';
import { NGXToastrService } from '../../../../../../src/app/shared/services/toastr.service';
import { Servicebillpipe, Storelistpipe } from '../../../pipes/actors/actorIdentity.pipes';
import { NgbPaymentModal } from './modal/payment.modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbBatchDetail2Modal } from '../consumptionentry/batchdetail2.modal';
import { PrintService } from '../../../../../../src/app/ncs/services/print.service';
import { NgbSearchProviderModal } from '../ivf/ivfworkbench/searchprovider.modal';
import { NgbGoodsInvoiceModal } from './modal/goodsinvoice.modal';





@Component({
  selector: 'indentadd',
  templateUrl: './indentadd.component.html',
  styleUrls: ['./indentadd.component.scss']
  , animations: [routerTransition()]
})

export class IndentAddComponent implements OnInit {


  public ApiResData: ApiResponseModel;
  public ShowList: boolean = true;
  public isRequesting: boolean = false;
  public searchValue: string;
  public isvisible: boolean = true;
  public Date: Date;
  public ActorCode2: number;
  public FacilityCode: number;
    searchTitle: string;
  RequestDate: NgbDateStruct;
  ExpectedDeliveryDate: NgbDateStruct;
  public Location: string;
  public RequestedBy: string;
  TodayDate = new Date();
  CurrentSavePurchaseIndentRequest: SavePurchaseIndentRequest;
                                      


  constructor(private router: Router,
    private actorservice: ActorService,
    public printService: PrintService,
    private route: ActivatedRoute, private loaderService: SpinnerService,
    private modalService: NgbModal,
    private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService,
    private filter: Storelistpipe, private spinner: NgxSpinnerService


  ) { }

  ngOnInit() {
    this.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.ActorCode2 = AppData.Instance().UserLoginDetails.ActorCode;
    this.Location = AppData.Instance().SelectedBranchName;
    this.RequestedBy = AppData.Instance().UserLoginDetails.UserName;
    this.CurrentSavePurchaseIndentRequest = new SavePurchaseIndentRequest();
    this.CurrentSavePurchaseIndentRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.RequestDate = {
                        year: this.TodayDate.getFullYear(),
                        month: this.TodayDate.getMonth() + 1,
                        day: this.TodayDate.getDate()
                       };
    //this.ExpectedDeliveryDate = {
    //                    year: this.TodayDate.getFullYear(),
    //                    month: this.TodayDate.getMonth() + 1,
    //                    day: this.TodayDate.getDate()
    //                   };
    this.StoreItems();
  }

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

  CurrentIndentDetails: Array<SavePurchaseIndentItem>;
  AddRow(l: MaterialsListController) {
    //alert("Add row");
    if (this.CurrentIndentDetails == null) {
      this.CurrentIndentDetails = new Array<SavePurchaseIndentItem>();
     
    }
    var itemExists = this.CurrentIndentDetails.find(x => x.MaterialCode == l.MaterialCode);
    if (itemExists != null) {
      // dont add again
      return;
    }
    else {
      var row = new SavePurchaseIndentItem();
      //row.RowNumber = row.RowNumber + 1;
      //row.MaterialDesscription = l.MaterialDesscription;
      row.MaterialCode = l.MaterialCode;
      row.MaterialDescription = l.MaterialDesscription;
      row.PurchaseIndentItemCode = 0;
      row.Quantity = 1;
      row.UOM = l.UOM;

      this.CurrentIndentDetails.push(row);
    }

  }

  SaveData() {
    this.spinner.show();
    this.CurrentSavePurchaseIndentRequest.OwnerName = AppData.Instance().UserLoginDetails.UserName;
    this.CurrentSavePurchaseIndentRequest.FromStore = this.StoreCode;
    this.CurrentSavePurchaseIndentRequest.OwnerLocationShortName = AppData.Instance().SelectedBranchName;
    this.CurrentSavePurchaseIndentRequest.RequestedDept = "";
    this.CurrentSavePurchaseIndentRequest.OwnerLocationCode = AppData.Instance().SelectedBranchCode;
    this.CurrentSavePurchaseIndentRequest.RequestedDate = new Date(this.parserFormatter.format(this.RequestDate));
    this.CurrentSavePurchaseIndentRequest.ExpectedDeliveryDate = new Date(this.parserFormatter.format(this.ExpectedDeliveryDate));
    this.CurrentSavePurchaseIndentRequest.ConditionalOperator = 10;
    this.CurrentSavePurchaseIndentRequest.Items = this.CurrentIndentDetails;
    //this.actorservice.SavePurchaseIndents(this.CurrentSavePurchaseIndentRequest)
    this.actorservice.Save<SavePurchaseIndentRequest>(
      this.CurrentSavePurchaseIndentRequest, S_Methods.SavePurchaseIndents
    )
      .subscribe((result) => {
        this.ApiResData = result;
        if (result.Result > 0) {
          this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
          this.stopRefreshing();
          this.spinner.hide();
          this.isvisible = false;
          this.router.navigate(['healins/purchaseindent']);
        }
        else {
          alertFunctions.AlertParam("Invalid Operation :- " + "...!");
          this.stopRefreshing();
          this.spinner.hide();
        }
      },
        (error) => {
          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();
          }
        }
      );
  }

  public istextshow: boolean = false;
  Qunatitychange(l: SavePurchaseIndentItem) {
    //alert("qty chn");
    //if (l.Quantity < 1) {
    //  this.isvisible = false;
    //  this.istextshow = true;
    //}
    //else //-- if (l.Quantity == 1 || l.Quantity > 1)
    //{
    //  this.isvisible = true;
    //  this.istextshow = false;
    //}
  }

  deletedPurchaseIndentDetails: Array<SavePurchaseIndentItem> = new Array<SavePurchaseIndentItem>();
  delete(i: number, l: SavePurchaseIndentItem) {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      allowOutsideClick: false,
      buttonsStyling: false
    }).then(() => {

      this.deleterow(i, l);

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })

  }

  deleterow(i: number, l: SavePurchaseIndentItem) {
    this.CurrentIndentDetails.splice(i, 1);
    if (this.deletedPurchaseIndentDetails != null) {
      var row = new SavePurchaseIndentItem();
        //row.RowNumber = row.RowNumber + 1;
      row.MaterialCode = l.MaterialCode;
      row.MaterialDescription = l.MaterialDescription;
      row.PurchaseIndentItemCode = l.PurchaseIndentItemCode;
      row.Quantity = l.Quantity;
      row.UOM = l.UOM;
      this.deletedPurchaseIndentDetails.push(row);
      }
  }

    CurrentMaterialsListRequest: MaterialsListRequest;
    CurrentMaterialsListController: MaterialsListController[];
    StoreItems() {
        // alert()
        this.CurrentMaterialsListRequest = new MaterialsListRequest();
        //this.pdata2 = this.ServicesByCategoryCodeController;

        this.CurrentMaterialsListRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.CurrentMaterialsListRequest.ConditionalOperator = 10;
        this.CurrentMaterialsListRequest.MaterialCode = 0;
        //this.pdata = this.CurrentStoreLocationMaterialsController;

        this.GetMaterialsListController();

    }
    RefreshPatients(st: string) {
        this.CurrentMaterialsListRequest = new MaterialsListRequest();
        this.CurrentMaterialsListRequest.ConditionalOperator = 20;
        this.CurrentMaterialsListRequest.SearchText = st;
        this.CurrentMaterialsListRequest.MaterialCode = 0;
        this.CurrentMaterialsListRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetMaterialsListController();
    }

    GetMaterialsListController() {
        this.StartRefreshing();
        //this.spinner.show();
        this.actorservice.GetMaterialsListController(this.CurrentMaterialsListRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                //alert(this.ApiResData.ErrorData);
                if (!this.ApiResData.hasError) {

                    this.CurrentMaterialsListController = this.ApiResData.Result;
                    //this.pdata = this.CurrentStoreLocationMaterialsController;
                    //this.spinner.hide();
                    this.stopRefreshing();

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );

    }
  criteriaChange(value: string) {
    //alert("naveen");
        this.RefreshPatients(value);


    }
    ClearInput() {
        this.searchValue = '';
        // this.searchValue = null;
        //var searchtext = '';
        this.RefreshPatients(this.searchValue);
    }

  Cancel() {
    this.router.navigate(['healins/purchaseindent']);
  }
  opbill() {

  }

  StoreCode: number = 0;
  public StoreName: string;
  onAssignedToActorCodesurgeon2(event: any) {
    if (event != null) {
      this.StoreName = event;
      this.StoreItems();
    }
  }
  StoreList_loaded(e: any) {

  }
}


